module.exports = __webpack_public_path__ + "static/media/ahmedabad.a4aa81ed.svg";